const isMobile = () => {
  return window.matchMedia('(max-width: 1224px)').matches;
};

export default isMobile;
